<template>
  <Card
    :title="title"
    :actions="[
      {
        label: $t('common.Add Property'),
        onAction: addItem,
        disabled: readonly
      }
    ]"
  >
    <CardSection
      v-for="(item, index) in items"
      :key="index"
      :title="$t('common.propertyNumber', { num: `${(index + 1)}` })"
      :actions="[
        {
          label: $t('common.Remove'),
          onAction: () => removeItemAt(index),
          disabled: readonly
        }
      ]"
    >
      <FormLayout>
        <FormLayoutGroup>
          <TextField
            :label="$t('common.Name')"
            :disabled="readonly"
            v-model="item.key"
          />
          <TextField
            :label="$t('common.Value')"
            :disabled="readonly"
            v-model="item.value"
          />
        </FormLayoutGroup>
        <FormLayoutGroup
          v-if="showOptions"
          condensed
        >
          <Select
            :label="$t('common.Update behavior')"
            :options="[
              {value: 'overwrite', label: $t('common.Overwrite previous value') },
              {value: 'setIfNotExists', label: $t('common.Set only if there is no value')}
            ]"
            :disabled="readonly"
            v-model="item.mode"
          />
          <TextField
            :label="$t('common.Expiry property in')"
            :suffix="$t('common.days')"
            :value="getExpiryDays(item.expireSeconds)"
            :disabled="readonly"
            @input="val => setExpiryDays(item, val)"
          />
        </FormLayoutGroup>
      </FormLayout>
    </CardSection>
    <CardSection
      v-if="!items.length"
    >
      {{$t('common.No properties')}}
    </CardSection>
  </Card>
</template>

<script>
export default {
  inject: ['$t'],
  props: {
    items: {
      type: Array,
      required: true
    },
    showOptions: {
      type: Boolean,
      required: true
    },
    title: {
      type: String
    },
    readonly: {
      type: Boolean
    }
  },
  mounted() {
    if (!this.title) {
      this.title = this.$t('common.Properties')
    }
  },
  methods: {
    addItem() {
      this.items.push({
        key: null,
        value: null,
        mode: 'overwrite',
        expireSeconds: 0
      })
    },
    removeItemAt(index) {
      this.items.splice(index, 1)
    },
    getExpiryDays(secs) {
      return secs / 86400
    },
    setExpiryDays(item, days) {
      item.expireSeconds = days * 86400
    }
  }
}
</script>
